import { Graph } from "components/common/Graph";
import {
    CapacityCostDataPoint,
    formatCostValue
} from "./costGraphsSectionHelpers";
import { CostReferenceLines } from "./CostReferenceLines";

type CostGraphProps = {
    readonly data: CapacityCostDataPoint[];
    readonly showPerMW: boolean;
    readonly costLabel: string;
    readonly xAxisLabel: string;
    readonly yRange: [number, number];
    readonly chartRef: React.RefObject<HTMLDivElement>;
    readonly renderTooltip: (tooltipProps: {
        active?: boolean;
        payload?: ReadonlyArray<{ payload: CapacityCostDataPoint }>;
        selectedPoint: number | null;
    }) => React.ReactNode;
    readonly xDomain: [number, number] | null;
    readonly onXDomainChange: (domain: [number, number] | null) => void;
    readonly projectSize?: number;
    readonly costAtProjectSize?: number;
    readonly costPerMWAtProjectSize?: number;
    readonly graphTitle?: string;
};

export const CostGraph: React.FC<CostGraphProps> = ({
    data,
    showPerMW,
    costLabel,
    xAxisLabel,
    yRange,
    chartRef,
    renderTooltip,
    xDomain,
    onXDomainChange,
    projectSize,
    costAtProjectSize,
    costPerMWAtProjectSize,
    graphTitle
}) => {
    // Compute conditional values once
    const yDataKey = showPerMW ? "costPerMW" : "cost";
    const yAxisLabel = showPerMW
        ? `${costLabel} per MW ($/MW)`
        : `${costLabel} ($)`;
    const lineName = showPerMW ? `${costLabel} per MW` : costLabel;

    return (
        <Graph<CapacityCostDataPoint>
            data={data}
            yDataKey={yDataKey}
            xAxisLabel={xAxisLabel}
            yAxisConfig={{
                label: yAxisLabel,
                tickFormatter: (value: number) => formatCostValue(value),
                domain: yRange
            }}
            chartRef={chartRef}
            renderTooltip={renderTooltip}
            lineName={lineName}
            xDomain={xDomain}
            onXDomainChange={onXDomainChange}
            graphTitle={graphTitle}
        >
            <CostReferenceLines
                showPerMW={showPerMW}
                costAtProjectSize={costAtProjectSize}
                costPerMWAtProjectSize={costPerMWAtProjectSize}
                projectSize={projectSize}
            />
        </Graph>
    );
};
